import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import PropTypes from 'prop-types';
import { SidebarProjectList } from '../../../components/sidebarProjectList';
import { SidebarSkillList } from '../../../components/sidebarSkillList';
import { projects } from '../../../data/projects';
import { skills } from '../../../data/skills';
import { general } from '../../../data/general';

const HomeSidebar = (props) => {
  return (
    <React.Fragment>
      <div className="photo">
        <img
          src={process.env.PUBLIC_URL + '/photo.jpg'}
          alt={props.i18n.name}
        />
      </div>

      <h1 className="print-only">Valerii Aligorskii</h1>
      <h2 className={'subtitle profession print-only'}>
        {props.i18n.profession}
      </h2>

      <div className={'sidebar-header'}>
        <div className={'sidebar-header-icon-wrapper color-blue'}>
          <FontAwesomeIcon icon="comments" />
        </div>
        <span>{props.i18n['personal.info']}</span>
      </div>
      <ul className={'sidebar-list'}>
        <li>
          <div className={'sidebar-list-icon-wrapper'}>
            <FontAwesomeIcon icon="map-marker" />
          </div>
          <span>{props.i18n.location}</span>
        </li>
        <li>
          <div className={'sidebar-list-icon-wrapper'}>
            <FontAwesomeIcon icon="phone" />
          </div>
          <a href={general.phone.href}>{general.phone.number}</a>
        </li>
        <li>
          <div className={'sidebar-list-icon-wrapper'}>
            <FontAwesomeIcon icon="at" />
          </div>
          <a href={`mailto:${general.email}`}>{general.email}</a>
        </li>
        <li>
          <div className={'sidebar-list-icon-wrapper'}>
            <FontAwesomeIcon icon={general.social.facebook.icon} />
          </div>
          <a
            href={`https://www.facebook.com/${general.social.facebook.username}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            {general.social.facebook.username}
          </a>
        </li>
        <li>
          <div className={'sidebar-list-icon-wrapper'}>
            <FontAwesomeIcon icon={general.social.vk.icon} />
          </div>
          <a
            href={`https://vk.com/${general.social.vk.username}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            {general.social.vk.username}
          </a>
        </li>
      </ul>

      <div className={'sidebar-header clear-print'}>
        <div className={'sidebar-header-icon-wrapper color-green'}>
          <FontAwesomeIcon icon="laptop" />
        </div>
        <span>{props.i18n.projects}</span>
      </div>
      <SidebarProjectList projects={projects} />

      <div className={'sidebar-header'}>
        <div className={'sidebar-header-icon-wrapper color-purple'}>
          <FontAwesomeIcon icon="pencil-alt" />
        </div>
        <span>{props.i18n.skills}</span>
      </div>
      <SidebarSkillList skills={skills} />

      <div className={'sidebar-header'}>
        <div className={'sidebar-header-icon-wrapper color-red'}>
          <FontAwesomeIcon icon="heart" />
        </div>
        <span>{props.i18n.hobbys}</span>
      </div>
      <div className={'sidebar-section'}>
        <div className={'bullet-list centered'}>
          {Object.keys(props.i18n.hobbysList).map((key) => {
            const value = props.i18n.hobbysList[key];
            return typeof value === 'string' ? (
              <span>{value}</span>
            ) : (
              <a href={value.href} target={'_blank'} rel="noopener noreferrer">
                {value.title}
              </a>
            );
          })}
        </div>
      </div>
    </React.Fragment>
  );
};

HomeSidebar.propTypes = {
  i18n: PropTypes.object.isRequired,
};

export default HomeSidebar;
